import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TASK_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetCalendarParams,
  GetCalendarResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (data: GetCalendarResponse) => void
  children?: (data: GetCalendarResponse) => ReactElement
  params?: GetCalendarParams
}

const GetTaskCalendarRequest = ({
  onError,
  onSuccess,
  children,
  params
}: Props) => {
  const url = `${TASK_SERVICE}/calendar`

  const { requestParams } = useGetParamsWithSpaceId<GetCalendarParams | undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default GetTaskCalendarRequest
